module.exports = __webpack_public_path__ + "img/坏笑.e053159c.gif";